import axios from 'axios';

const state = {
    isLoggedIn: false,
    userDetails: {},
};

const getters = {
    loggedIn(state) {
        return state.isLoggedIn;
    },
    userDetails(state) {
        return state.userDetails;
    }
};

const mutations = {
    setLoggedIn(state, payload) {
        state.isLoggedIn = payload;
    },
    setUserDetails(state, payload) {
        state.userDetails = payload;
    }
};

const actions = {
    me(ctx){
        return new Promise( (resolve, reject) => {
            axios.get('/users/me').then((response) => {
                ctx.commit('setUserDetails', response.data.data);
                resolve(response.data);
            })
                .catch((error) => {
                    reject(error);
                })
        });
    },
    loginUser(ctx, payload) {
        return new Promise((resolve, reject ) => {
            axios.post('/auth/login', payload)
                .then(response => {
                    if (response.data.access_token){
                        localStorage.setItem('token', response.data.access_token);
                        ctx.commit('setLoggedIn', true);
                        resolve(response);
                    }
                    else {
                        reject(response);
                    }
                    // this.$router.push({name: 'Dashboard'});
                })
                .catch((error) => {
                    reject(error);
                });
        })
    },

    logoutUser(ctx) {
        return new Promise( (resolve) => {
            localStorage.removeItem('token');
            ctx.commit('setLoggedIn', false);
            resolve(true);
        })
    },

    setLoggedInState(ctx) {
        return new Promise( (resolve) => {
            if (localStorage.getItem('token')) {
                ctx.commit('setLoggedIn', true);
                resolve(true);
            }
            else{
                ctx.commit('setLoggedIn', false);
                resolve(false);
            }
        });
    },

    forgotPassword(ctx, payload) {
        return new Promise( (resolve, reject) => {
            axios.post('/auth/forgot-password', payload)
                .then(response => {
                    resolve(response);
                    // this.$router.push({name: 'Dashboard'});
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    resetPassword(ctx, payload) {
        return new Promise( (resolve, reject) => {
            axios.post('/auth/reset-password', payload)
                .then(response => {
                    resolve(response);
                    // this.$router.push({name: 'Dashboard'});
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    patchMe(ctx, payload) {
        return new Promise( (resolve, reject) => {
            axios.patch('/users/me', payload)
                .then(response => {
                    resolve(response);
                    // this.$router.push({name: 'Dashboard'});
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}